import React from 'react';
import { Grid, makeStyles, Theme } from '@material-ui/core';
import { useHistory } from 'react-router';
import { WarningRounded } from '@material-ui/icons';
import { StyledText } from '../StyledText';
import Button from '../Button';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(0),
    borderRadius: '8px',
    padding: 25,
    border: '1px solid #FBBC05',
    backgroundColor: '#FFF'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  listWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: '19px',
    margintTop: '20px',

    '& .MuiList-root': {
      marginRight: '80px',
      padding: '15px 0px',

      '& .MuiListSubheader-root': {
        padding: 0,
        color: theme.palette.text.primary
      },

      '& .MuiListItem-gutters': {
        padding: 0,

        '& .MuiListItemText-root': {
          margin: 0,
          marginRight: '4px'
        }
      },

      '& .MuiListItem-root': {
        paddingBottom: '4px',
        '& p:hover': {
          cursor: 'pointer',
          fontWeight: 500
        },
        textTransform: 'capitalize'
      }
    }

  },
  text: {
    marginLeft: '19px',
    marginRight: '20px',
    whiteSpace: 'normal'
  },
  button: {
    marginLeft: '20px',
    whiteSpace: 'nowrap'
  },
  link: {
    '& p :hover': {
      fontWeight: 500
    }
  }
}));
interface NoDealsGuideProps {
  entId: number
}

const NoDealsGuide: React.FC<NoDealsGuideProps> = ({
  entId
}) => {
  const styles = useStyles();
  const history = useHistory();

  const message = 'To get funded you need to contact a connector.';

  const handleClick = () => {
    history.push(`/entrepreneur/${entId}/matched-investors/recommended`);
  };

  return (
    <Grid id='publishing-guide' container wrap='nowrap' direction='column' justify='center' className={styles.root}>
      <div className={styles.contentWrapper}>
        <WarningRounded htmlColor='#FBBC05' />
        <div className={styles.content}>
          <StyledText variant='body1' className={styles.text} style={{ whiteSpace: 'normal' }}>
            {message}
          </StyledText>
          <br />
          <Button
            onClick={handleClick}
            className={styles.button}
          >
            Take me there
          </Button>
        </div>
      </div>
    </Grid>
  );
};

export default NoDealsGuide;
